const getMixin = (propsObjInTheObj) => {
  const computedName = Object.keys(propsObjInTheObj)[0]
  const propsObj = propsObjInTheObj[computedName]
  return {
    computed: {
      [computedName]() {
        const bindings = {}
        Object.keys(propsObj).forEach(key => bindings[key] = this[key])
        return bindings
      },
    },
  }
}
/** =============For all modals================= */
export const allModalsProps = {
  noPortal: { type: Boolean }, // mainly to move portal logic into global modal
  noClose: { type: Boolean },
  noBack: { type: Boolean, default: true }, // btn back for nested modals
  noBackdrop: { type: Boolean },
  noClickOutside: { type: Boolean },
  noEsc: { type: Boolean },
  closeOnBack: { type: Boolean },
  colorBlack: { type: Boolean },
  colorBlur: { type: Boolean },
  colorGray: { type: Boolean },
  clearQuery: { type: Boolean },
  theme: { type: String, default: 'dark' },
  hidden: { type: Boolean }, // modal and its body stay in the DOM but becomes invisible
  dataGtmIdClose: { type: String },
  snowHeader: { type: Boolean, required: false },
}
export const bindings_allModalsProps = getMixin({ allModalsProps })
/** ==============BaseModal and LocalModal================ */
export const baseAndLocalModalProps = {
  noBodyPadding: { type: Boolean },
  maxWidth: { type: String }, // example: '400px'
  sizeSmall: { type: Boolean },
  sizeSmallToBig: { type: Boolean },
  sizeMobileFullScreen: { type: Boolean },
  fullScreen: { type: Boolean, default: false },
}
export const bindings_baseAndLocalModalProps = getMixin({ baseAndLocalModalProps })
/** =============LocalModal and ConfirmModal================= */
export const localModalAndItsDescendantsProps = {
  value: { type: Boolean, default: false },
  noControls: { type: Boolean },
  horizontalButtons: { type: Boolean, default: false },
  persistOnRoutePathChange: { type: Boolean },
  query: { type: String },
  queryKey: { type: String },
}
export const bindings_localModalAndItsDescendantsProps = getMixin({ localModalAndItsDescendantsProps })
